import {EditorProps} from 'components/Editor';

export function createParagraphsFromTextRaw(
  text: string,
): EditorProps['paragraphs'] {
  const paragraphsText = text.split('\n')?.filter((text) => text !== '');
  const paragraphs: EditorProps['paragraphs'] = new Map(
    paragraphsText?.length
      ? paragraphsText.map((_text, index) => [
          index.toString(),
          {
            start: paragraphsText.reduce<number>(
              (acc, current, currentIndex) => {
                if (currentIndex < index) {
                  return acc + current.length + 2;
                }
                return acc;
              },
              0,
            ),
            markers: [],
          },
        ])
      : [['0', {start: 0, markers: []}]],
  );

  return paragraphs;
}

export interface Marker {
  competence_id?: number;
  id: number;
  paragraph: number;
  start: number;
  end: number;
  className?: string;
  onMouseEnter?(): void;
  onMouseLeave?(): void;
  onClick?(): void;
}

export function insertMarkersIntoParagraphs(
  paragraphs: EditorProps['paragraphs'],
  markers: Marker[],
): EditorProps['paragraphs'] {
  return new Map(
    Array.from(paragraphs ?? []).map(([key, value]) => [
      key,
      {
        ...value,
        markers: markers
          ?.filter((marker) => Number(key) === Number(marker.paragraph))
          ?.map((marker) => ({
            id: marker.id,
            start: marker.start,
            end: marker.end,
            onMouseEnter: marker.onMouseEnter,
            onMouseLeave: marker.onMouseLeave,
            onClick: marker.onClick,
            className: marker.className,
          })),
      },
    ]),
  );
}
